/** @format */

import ReactDOM from 'react-dom/client';
import App from './App';
import AppContextProvider from './store/store.app';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppContextProvider>
    <App />
  </AppContextProvider>
);
